document.addEventListener('DOMContentLoaded', function(){
    setInterval(function(){
        $('.row.row-0.products.products-grid.grid-4.layout-2.slick-initialized.slick-slider.slick-dotted').slick('refresh')
    }, 1500);

  setTimeout(function(){
  if (window.location.href.indexOf('#') > -1){
    const needid = window.location.href.split('#')[1];
    const elementToScrollTo = document.getElementById(needid);

    if (document.querySelector(`[href="#${needid}"]`)){
      document.querySelector(`[href="#${needid}"]`).click();
    }

    setTimeout(function(){
      if (elementToScrollTo){
        const rect = elementToScrollTo.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        window.scrollTo({ 
          top: rect.top + scrollTop - 150, 
          behavior: 'smooth' 
        });
      }
    }, 300)
  }
  }, 500);
})